// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3gTW9","infoBtn":"quickbooks_infoBtn__1BJHj","formBox":"quickbooks_formBox__vkOvr","formFooter":"quickbooks_formFooter__1aX-6"};